import api from './axios';

export const athleteAPI = {
  register: async (formData) => {
    const response = await api.post('/athletes/register', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Resume registration for incomplete payment
  resumeRegistration: async (credentials) => {
    const response = await api.post('/athletes/resume-registration', credentials);
    return response.data;
  },

  login: async (credentials) => {
    const response = await api.post('/athletes/login', credentials);
    return response.data;
  },

  getProfile: async () => {
    const response = await api.get('/athletes/profile');
    return response.data;
  },

  updateProfile: async (formData) => {
    const response = await api.put('/athletes/profile', formData,{
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // NEW: Admit Card APIs
  getAdmitCardStatus: async () => {
    const response = await api.get('/athletes/admit-card/status');
    return response.data;
  },

  downloadAdmitCard: async () => {
    const response = await api.get('/athletes/admit-card/download', {
      responseType: 'blob', // Important for file download
    });
    return response.data;
  },

  forgotPassword: async (data) => {
    const response = await api.post('/athletes/forgot-password', data);
    return response.data;
  },

  verifyPasswordResetOTP: async (data) => {
    const response = await api.post('/athletes/verify-password-reset-otp', data);
    return response.data;
  },

  resetPassword: async (data) => {
    const response = await api.post('/athletes/reset-password', data);
    return response.data;
  },

  sendVerificationOTP: async (email) => {
    const response = await api.post('/athletes/send-verification-otp', { email });
    return response.data;
  },

  verifyRegistrationOTP: async (data) => {
    const response = await api.post('/athletes/verify-otp', data);
    return response.data;
  },
};